// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2XihU","header":"MergedInvoice_header__2onQG"};